import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import React from 'react';
import styled from 'styled-components';
import Quote from '@client/assets/svgs/quote.svg';

const Container = styled.div<{ $bg?: string; $fg?: string }>`
	padding-top: 40px;
	padding-bottom: 40px;
	background-color: ${props => props.$bg};
	color: ${props => props.$fg};
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	${Functions.breakpoint(Breakpoints.mobile)} {
		padding-top: 80px;
		/* padding-bottom: 80px; */
	}

	&:has(+ .BreakerModule) {
		border-bottom: var(--breaker-total) solid transparent;
	}
`;

const QuoteSign = styled.div<{ $fg?: string }>`
	width: 40px;
	height: 32px;
	color: ${props => props.$fg || '#262C2E'};
`;

const QuoteContainer = styled.div`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p4')}
	margin: 0 var(--gridMargin);
	${Functions.breakpoint(Breakpoints.mobile)} {
		max-width: 940px;
		${TextStyle.size('p2')}
	}
	text-align: center;
	margin-bottom: 20px;
	margin-top: 20px;
`;

const AuthorContainer = styled.div`
	${TextStyle.size('large')}
	text-align: center;
	${TextStyle.family('title')}
`;

interface QuoteProps {
	data: {
		quoteText: string;
		quoteAuthor: string;
		backgroundColor: any;
	};
}

export default function QuoteModule(props: QuoteProps) {
	return (
		<Container
			className='colorWrapperAnimatedModule'
			$bg={props.data.backgroundColor?.color}
			$fg={props.data.backgroundColor?.contrastColor}
		>
			<QuoteSign $fg={props.data.backgroundColor?.contrastColor}>
				<Quote />
			</QuoteSign>
			<QuoteContainer>{props.data.quoteText}</QuoteContainer>
			<AuthorContainer>{props.data.quoteAuthor}</AuthorContainer>
		</Container>
	);
}
